import { Injectable } from '@angular/core';
import { interval, Observable, take } from 'rxjs';

import { Token } from '../interfaces/core/token.interface';

@Injectable({
  providedIn: 'root',
})
export class TokenRefreshHandler {
  protected refreshTokenPeriod$: Observable<number> | undefined;

  public run(tokens: Token, minutesPrevious = 1): void {
    const unixDate: number = Math.floor(Date.now() / 1000);
    const diffDates: number = tokens.expiresIn - unixDate;
    const intervalToGetTokens: number =
      (diffDates - minutesPrevious * 60) * 1000;

    if (!this.refreshTokenPeriod$) {
      this.refreshTokenPeriod$ = interval(intervalToGetTokens).pipe(take(1));
    }
  }

  public getRefreshTokenPeriodObservable(): Observable<number> | undefined {
    if (this.refreshTokenPeriod$) {
      return this.refreshTokenPeriod$;
    }

    return undefined;
  }

  public resetRefreshTokenPeriodObservable(): void {
    this.refreshTokenPeriod$ = undefined;
  }
}
